import { render, staticRenderFns } from "./ConsentsView.vue?vue&type=template&id=2414d77d"
import script from "./ConsentsView.vue?vue&type=script&lang=js"
export * from "./ConsentsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports